import React from 'react';
import { Target, CheckCircle } from 'lucide-react';
export function ForWhoSection() {
  return;
}